import { render } from "./WebVersionManage.vue?vue&type=template&id=46dcb363"
import script from "./WebVersionManage.vue?vue&type=script&lang=js"
export * from "./WebVersionManage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__